

























import {
  Vue,
  Component
} from "@/shared/vuepack";
import { useDebitCardManagementStore } from "@/shared/store/debitCardManagement";
import { DebitCardDeactivationReasons, DebitCardManagerModalViewState } from "@/shared/types";
import { useThemeStore } from "@/shared/store/theme";

@Component({
  components: {}
})
export default class DeactivateCardForm extends Vue {
  debitCardManagementStore = useDebitCardManagementStore();
  themeStore = useThemeStore();

  selected = null;

  get deactivationReasonsOptions () {
    return [
      {value: DebitCardDeactivationReasons.Lost, text: "Lost"},
      {value: DebitCardDeactivationReasons.Stolen, text: "Stolen"},
      {value: DebitCardDeactivationReasons.FraudulentActivity, text: "Fraudulent charges/activity"},
      {value: DebitCardDeactivationReasons.DamagedCard, text: "Card is damaged"}
    ];
  }

  get submitDisabled () {
    return this.selected === null;
  }

  onSubmitChanges (e: Event) {
    e.preventDefault();

    this.debitCardManagementStore.deactivationReason = this.selected;

    this.debitCardManagementStore.setModalState(DebitCardManagerModalViewState.ConfirmAddressForm);
  }
}
